import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

// Definição de todas as páginas do sistema com seus identificadores únicos
export const TODAS_PAGINAS = {
  // DNACore - Núcleo Pedagógico com IA
  dnacore: { label: 'DNACore', categoria: 'dnacore', path: '/dnacore' },
  dnacore_v2: { label: 'DNACore V2', categoria: 'dnacore', path: '/dnacore-v2' },
  
  // Central de Notas
  central_notas: { label: 'Central de Notas', categoria: 'dnacore', path: '/central-notas' },
  central_notas_pendencias: { label: 'IA Pendências', categoria: 'dnacore', path: '/central-notas/pendencias' },
  semana_avaliacoes: { label: 'Semana de Avaliações', categoria: 'dnacore', path: '/semana-avaliacoes' },
  
  // Financeiro - DNA Pay
  dnapay_dashboard: { label: 'DNA Pay', categoria: 'financeiro', path: '/financeiro' },
  dashboard: { label: 'Dashboard Financeiro', categoria: 'financeiro', path: '/dashboard' },
  collection: { label: 'Cobrança', categoria: 'financeiro', path: '/collection' },
  geracao_cobranca: { label: 'Geração de Boletos', categoria: 'financeiro', path: '/geracao-cobranca' },
  integracao_bancaria: { label: 'Integração Bancária', categoria: 'financeiro', path: '/integracao-bancaria' },
  folha_pagamento: { label: 'Folha de Pagamento', categoria: 'financeiro', path: '/folha-pagamento' },
  titles: { label: 'Títulos', categoria: 'financeiro', path: '/titles' },
  contas_bancarias: { label: 'Contas Bancárias', categoria: 'financeiro', path: '/contas-bancarias' },
  financial_entries: { label: 'Lançamentos', categoria: 'financeiro', path: '/financial-entries' },
  dre: { label: 'DRE', categoria: 'financeiro', path: '/dre' },
  rateio: { label: 'Rateio', categoria: 'financeiro', path: '/rateio' },
  bases_rateio: { label: 'Bases Rateio', categoria: 'financeiro', path: '/bases-rateio' },
  expenses: { label: 'Despesas', categoria: 'financeiro', path: '/expenses' },
  financial_plans: { label: 'Planos Financeiros', categoria: 'financeiro', path: '/financial-plans' },
  bank: { label: 'Banco', categoria: 'financeiro', path: '/bank' },
  defaulters: { label: 'Inadimplentes', categoria: 'financeiro', path: '/defaulters' },
  dnapay_gerar_titulos: { label: 'Gerar Títulos DNA Pay', categoria: 'financeiro', path: '/dnapay/gerar-titulos' },
  dnapay_cobrancas_automaticas: { label: 'Cobranças Automáticas', categoria: 'financeiro', path: '/dnapay/cobrancas-automaticas' },
  dnapay_scheduler: { label: 'Agendador de Tarefas', categoria: 'financeiro', path: '/dnapay/scheduler' },
  dnapay_renegociacao: { label: 'Renegociação', categoria: 'financeiro', path: '/dnapay/renegociacao' },
  dnapay_mensageria: { label: 'Central de Mensageria', categoria: 'financeiro', path: '/dnapay/mensageria' },
  
  // Pedagógico
  students: { label: 'Alunos', categoria: 'pedagogico', path: '/students' },
  boletim: { label: 'Boletim', categoria: 'pedagogico', path: '/boletim' },
  class_schedule: { label: 'Horários de Aula', categoria: 'pedagogico', path: '/class-schedule' },
  teacher_portal: { label: 'Portal Equipe DNA', categoria: 'pedagogico', path: '/teacher-portal' },
  teacher_assignments: { label: 'Vincular Professores', categoria: 'pedagogico', path: '/teacher-assignments' },
  class_groups: { label: 'Turmas', categoria: 'pedagogico', path: '/class-groups' },
  courses: { label: 'Cursos', categoria: 'pedagogico', path: '/courses' },
  curriculums: { label: 'Matrizes Curriculares', categoria: 'pedagogico', path: '/curriculums' },
  carteirinhas: { label: 'Carteirinhas', categoria: 'pedagogico', path: '/carteirinhas' },
  agenda: { label: 'Agenda', categoria: 'pedagogico', path: '/agenda' },
  documentos: { label: 'Editor de Documentos', categoria: 'pedagogico', path: '/documentos' },
  
  // DNA.IA
  dna_ia: { label: 'Avaliação de Fluência', categoria: 'dna_ia', path: '/dna-ia' },
  assistente_ia: { label: 'Assistente IA', categoria: 'dna_ia', path: '/assistente-ia' },
  tabuada: { label: 'Gerador de Tabuada', categoria: 'dna_ia', path: '/tabuada' },
  quiz_milionario: { label: 'Desafios dos Campeões', categoria: 'dna_ia', path: '/quiz-milionario' },
  interclasse: { label: 'Interclasse', categoria: 'dna_ia', path: '/interclasse' },
  torneio_profissional: { label: 'Torneio Profissional', categoria: 'dna_ia', path: '/torneio-profissional' },
  
  // Marketing/Comercial
  aniversariantes: { label: 'Aniversariantes', categoria: 'marketing', path: '/aniversariantes' },
  canva: { label: 'Canva (Externo)', categoria: 'marketing', path: '/canva-redirect' },
  campanhas: { label: 'Campanhas', categoria: 'marketing', path: '/campanhas' },
  templates: { label: 'Templates', categoria: 'marketing', path: '/templates' },
  mural_comunicados: { label: 'Mural de Comunicados', categoria: 'marketing', path: '/mural-comunicados' },
  
  // Administrativo
  employees: { label: 'Equipe DNA', categoria: 'administrativo', path: '/employees' },
  time_records: { label: 'Ponto', categoria: 'administrativo', path: '/time-records' },
  usuarios: { label: 'Usuários e Permissões', categoria: 'administrativo', path: '/usuarios' },
  communication: { label: 'Comunicação', categoria: 'administrativo', path: '/communication' },
  reminders: { label: 'Lembretes', categoria: 'administrativo', path: '/reminders' },
  alert_settings: { label: 'Alertas', categoria: 'administrativo', path: '/alert-settings' },
  import_export: { label: 'Importar/Exportar', categoria: 'administrativo', path: '/import-export' },
  logs: { label: 'Logs', categoria: 'administrativo', path: '/logs' },
  settings: { label: 'Configurações', categoria: 'administrativo', path: '/settings' },
  
  // Fiscal / Notas Fiscais
  fiscal_dashboard: { label: 'Dashboard Fiscal', categoria: 'fiscal', path: '/fiscal' },
  fiscal_emissao: { label: 'Emissão de NFS-e', categoria: 'fiscal', path: '/fiscal/emissao' },
  fiscal_notas: { label: 'Notas Emitidas', categoria: 'fiscal', path: '/fiscal/notas' },
  fiscal_config: { label: 'Configurações Fiscais', categoria: 'fiscal', path: '/fiscal/config' },
  fiscal_empresas: { label: 'Empresas Emissoras', categoria: 'fiscal', path: '/fiscal/empresas' },
  fiscal_relatorios: { label: 'Relatórios Fiscais', categoria: 'fiscal', path: '/fiscal/relatorios' },
  fiscal_integracao: { label: 'Integração Prefeitura', categoria: 'fiscal', path: '/fiscal/integracao' },
  fiscal_logs: { label: 'Logs e Auditoria', categoria: 'fiscal', path: '/fiscal/logs' },
  fiscal_erros: { label: 'Erros de Emissão', categoria: 'fiscal', path: '/fiscal/erros' },

  // Central de Importação de Títulos Financeiros
  import_titles: { label: 'Importar Títulos', categoria: 'financeiro', path: '/finance/import-titles' },

  // Tributário
  tributario_dashboard: { label: 'Dashboard Tributário', categoria: 'tributario', path: '/tributario' },
  tributario_config: { label: 'Configurações', categoria: 'tributario', path: '/tributario/config' },
  tributario_apuracao: { label: 'Apuração de Tributos', categoria: 'tributario', path: '/tributario/apuracao' },
  tributario_memoria: { label: 'Memória de Cálculo', categoria: 'tributario', path: '/tributario/memoria' },
  tributario_simulacoes: { label: 'Simulações', categoria: 'tributario', path: '/tributario/simulacoes' },
  tributario_relatorios: { label: 'Relatórios Fiscais', categoria: 'tributario', path: '/tributario/relatorios' },
  tributario_logs: { label: 'Logs e Auditoria', categoria: 'tributario', path: '/tributario/logs' },

  // Dashboard Executivo
  executivo_dashboard: { label: 'Dashboard Executivo', categoria: 'executivo', path: '/executivo' },
  executivo_dre: { label: 'DRE Gerencial', categoria: 'executivo', path: '/executivo/dre' },
  executivo_segmentos: { label: 'Análise por Segmento', categoria: 'executivo', path: '/executivo/segmentos' },
  executivo_forecast: { label: 'Forecast e Projeções', categoria: 'executivo', path: '/executivo/forecast' },
  
  // Estratégico
  estrategico_expansao: { label: 'Simulação de Expansão', categoria: 'estrategico', path: '/estrategico/expansao' },
  estrategico_custos: { label: 'Corte de Custos', categoria: 'estrategico', path: '/estrategico/custos' },
  
  // Relatórios
  relatorio_consolidado: { label: 'Relatório Consolidado', categoria: 'relatorios', path: '/relatorio-consolidado' },
  analytics: { label: 'Analytics', categoria: 'relatorios', path: '/analytics' },
  relatorios: { label: 'Relatórios Gerais', categoria: 'relatorios', path: '/relatorios' },
  
  // DNA GO
  dnago_painel: { label: 'Painel de Saída', categoria: 'dnago', path: '/dnago/painel' },
  dnago_portaria: { label: 'Painel Portaria', categoria: 'dnago', path: '/dnago/portaria' },
  dnago_dashboard: { label: 'Dashboard', categoria: 'dnago', path: '/dnago/dashboard' },
  dnago_autorizados: { label: 'Autorizados', categoria: 'dnago', path: '/dnago/autorizados' },
  dnago_retiradas: { label: 'Retiradas', categoria: 'dnago', path: '/dnago/retiradas' },
  dnago_vans: { label: 'Vans', categoria: 'dnago', path: '/dnago/vans' },
  dnago_ocorrencias: { label: 'Ocorrências', categoria: 'dnago', path: '/dnago/ocorrencias' },
  
  // DNA CONNECT
  dnaconnect_admin: { label: 'Central de Liberação', categoria: 'dnaconnect', path: '/dnaconnect-admin' },
  aulas_extras_admin: { label: 'Aulas Extras 2026', categoria: 'dnaconnect', path: '/aulas-extras-admin' },
  
  // DNA GROWTH ENGINE
  growth_dashboard: { label: 'Dashboard Growth', categoria: 'growth', path: '/growth' },
  growth_crm: { label: 'CRM - Leads', categoria: 'growth', path: '/growth/crm' },
  growth_social: { label: 'Social AI', categoria: 'growth', path: '/growth/social' },
  growth_atendimento: { label: 'Atendimento AI', categoria: 'growth', path: '/growth/atendimento' },
  growth_ads: { label: 'Ads AI', categoria: 'growth', path: '/growth/ads' },
  growth_funnel: { label: 'Funnel AI', categoria: 'growth', path: '/growth/funnel' },
  growth_whatsapp: { label: 'WhatsApp AI', categoria: 'growth', path: '/growth/whatsapp' },
  growth_analytics: { label: 'Growth AI', categoria: 'growth', path: '/growth/analytics' },
  growth_reputation: { label: 'Reputation AI', categoria: 'growth', path: '/growth/reputation' },
  
  // CALENDÁRIO ESCOLAR
  calendario: { label: 'Calendário Escolar', categoria: 'calendario', path: '/calendario' },
};

// Labels dos tipos de acao
export const ACOES_LABELS = {
  view: 'Visualizar',
  create: 'Criar',
  edit: 'Editar',
  delete: 'Excluir',
  export: 'Exportar',
  print: 'Imprimir',
  publish: 'Publicar',
  manage: 'Gerenciar',
  approve: 'Aprovar',
};

// Acoes disponiveis por pagina do sistema
export const ACOES_POR_PAGINA = {
  // DNACore
  dnacore: ['view'],
  dnacore_v2: ['view'],
  central_notas: ['view', 'edit', 'export'],
  central_notas_pendencias: ['view', 'export'],
  semana_avaliacoes: ['view', 'create', 'edit', 'delete', 'publish', 'print', 'export'],
  // Financeiro
  dnapay_dashboard: ['view'],
  dashboard: ['view', 'export'],
  collection: ['view', 'create', 'edit', 'delete', 'export'],
  geracao_cobranca: ['view', 'create', 'export'],
  integracao_bancaria: ['view', 'manage'],
  folha_pagamento: ['view', 'create', 'edit', 'export'],
  titles: ['view', 'create', 'edit', 'delete', 'export'],
  contas_bancarias: ['view', 'create', 'edit', 'delete'],
  financial_entries: ['view', 'create', 'edit', 'delete', 'export'],
  dre: ['view', 'export'],
  rateio: ['view', 'create', 'edit', 'delete'],
  bases_rateio: ['view', 'create', 'edit', 'delete'],
  expenses: ['view', 'create', 'edit', 'delete', 'export'],
  financial_plans: ['view', 'create', 'edit', 'delete'],
  bank: ['view', 'manage'],
  defaulters: ['view', 'export'],
  import_titles: ['view', 'create'],
  dnapay_gerar_titulos: ['view', 'create'],
  dnapay_cobrancas_automaticas: ['view', 'manage'],
  dnapay_scheduler: ['view', 'manage'],
  dnapay_renegociacao: ['view', 'create', 'edit'],
  dnapay_mensageria: ['view', 'create'],
  // Pedagogico
  students: ['view', 'create', 'edit', 'delete', 'export'],
  boletim: ['view', 'edit', 'export', 'print'],
  class_schedule: ['view', 'create', 'edit'],
  teacher_portal: ['view'],
  teacher_assignments: ['view', 'create', 'edit', 'delete'],
  class_groups: ['view', 'create', 'edit', 'delete'],
  courses: ['view', 'create', 'edit', 'delete'],
  curriculums: ['view', 'create', 'edit', 'delete'],
  carteirinhas: ['view', 'create', 'print'],
  agenda: ['view', 'create', 'edit', 'delete'],
  documentos: ['view', 'create', 'edit', 'delete', 'print'],
  // DNA.IA
  dna_ia: ['view'],
  assistente_ia: ['view'],
  tabuada: ['view', 'create'],
  quiz_milionario: ['view', 'create', 'manage'],
  interclasse: ['view', 'create', 'manage'],
  torneio_profissional: ['view', 'create', 'manage'],
  // Marketing
  aniversariantes: ['view', 'export'],
  canva: ['view'],
  campanhas: ['view', 'create', 'edit', 'delete'],
  templates: ['view', 'create', 'edit', 'delete'],
  mural_comunicados: ['view', 'create', 'edit', 'delete', 'publish'],
  // Administrativo
  employees: ['view', 'create', 'edit', 'delete'],
  time_records: ['view', 'create', 'edit', 'export'],
  usuarios: ['view', 'create', 'edit', 'delete', 'manage'],
  communication: ['view', 'create'],
  reminders: ['view', 'create', 'edit', 'delete'],
  alert_settings: ['view', 'manage'],
  import_export: ['view', 'manage'],
  logs: ['view'],
  settings: ['view', 'manage'],
  // Fiscal
  fiscal_dashboard: ['view'],
  fiscal_emissao: ['view', 'create'],
  fiscal_notas: ['view', 'export'],
  fiscal_config: ['view', 'manage'],
  fiscal_relatorios: ['view', 'export'],
  fiscal_integracao: ['view', 'manage'],
  fiscal_logs: ['view'],
  fiscal_erros: ['view'],
  // Tributario
  tributario_dashboard: ['view'],
  tributario_config: ['view', 'manage'],
  tributario_apuracao: ['view', 'create', 'export'],
  tributario_memoria: ['view', 'export'],
  tributario_simulacoes: ['view', 'create'],
  tributario_relatorios: ['view', 'export'],
  tributario_logs: ['view'],
  // Executivo
  executivo_dashboard: ['view'],
  executivo_dre: ['view', 'export'],
  executivo_segmentos: ['view'],
  executivo_forecast: ['view'],
  // Estrategico
  estrategico_expansao: ['view'],
  estrategico_custos: ['view'],
  // Relatorios
  relatorio_consolidado: ['view', 'export'],
  analytics: ['view', 'export'],
  relatorios: ['view', 'export'],
  // DNA GO
  dnago_painel: ['view', 'manage'],
  dnago_portaria: ['view', 'manage'],
  dnago_dashboard: ['view'],
  dnago_autorizados: ['view', 'create', 'edit', 'delete'],
  dnago_retiradas: ['view', 'create'],
  dnago_vans: ['view', 'create', 'edit', 'delete'],
  dnago_ocorrencias: ['view', 'create', 'edit'],
  // DNA CONNECT
  dnaconnect_admin: ['view', 'create', 'delete', 'manage'],
  aulas_extras_admin: ['view', 'create', 'edit', 'delete'],
  // Growth Engine
  growth_dashboard: ['view'],
  growth_crm: ['view', 'create', 'edit', 'delete'],
  growth_social: ['view', 'create'],
  growth_atendimento: ['view', 'create'],
  growth_ads: ['view', 'create'],
  growth_funnel: ['view'],
  growth_whatsapp: ['view', 'create'],
  growth_analytics: ['view'],
  growth_reputation: ['view'],
  // Calendario
  calendario: ['view', 'create', 'edit', 'delete'],
};

// Lista de categorias
export const CATEGORIAS = ['financeiro', 'pedagogico', 'dna_ia', 'marketing', 'administrativo', 'relatorios', 'dnago', 'dnaconnect', 'growth', 'fiscal', 'tributario', 'executivo', 'estrategico', 'calendario'];

// Gerar todas as permissões de página para um perfil
const gerarPermissoesPadrao = (paginasPermitidas) => {
  const permissoes = { paginas: {} };
  Object.keys(TODAS_PAGINAS).forEach(pagina => {
    permissoes.paginas[pagina] = paginasPermitidas.includes(pagina);
  });
  return permissoes;
};

// ══════════════════════════════════════════════════════════════
// PERMISSÕES PADRÃO POR PERFIL — CONTROLE REAL
// Admin configura permissões personalizadas na tela de Usuários.
// Estes são os DEFAULTS quando o admin NÃO configurou.
// ══════════════════════════════════════════════════════════════
const TODAS_PAGINAS_IDS = Object.keys(TODAS_PAGINAS);

// Professor: apenas pedagógico básico + IA
const PAGINAS_PROFESSOR = [
  'teacher_portal', 'central_notas', 'central_notas_pendencias',
  'boletim', 'class_schedule', 'agenda', 'documentos',
  'dna_ia', 'assistente_ia', 'tabuada', 'quiz_milionario', 'interclasse', 'torneio_profissional',
  'calendario',
];

// Coordenação/Secretaria: pedagógico completo + comunicação + DNA GO
const PAGINAS_COORDENACAO = [
  ...PAGINAS_PROFESSOR,
  'students', 'class_groups', 'courses', 'curriculums', 'carteirinhas',
  'teacher_assignments', 'semana_avaliacoes', 'dnacore', 'dnacore_v2',
  'communication', 'reminders', 'alert_settings', 'mural_comunicados',
  'aniversariantes', 'campanhas', 'templates',
  'relatorios', 'relatorio_consolidado', 'analytics',
  'dnaconnect_admin', 'aulas_extras_admin',
  'dnago_painel', 'dnago_portaria', 'dnago_dashboard', 'dnago_autorizados',
  'dnago_retiradas', 'dnago_vans', 'dnago_ocorrencias',
];

// Financeiro: todo o módulo financeiro + fiscal + tributário + executivo
const PAGINAS_FINANCEIRO = [
  'dnapay_dashboard', 'dashboard', 'collection', 'geracao_cobranca',
  'integracao_bancaria', 'folha_pagamento', 'titles', 'contas_bancarias',
  'financial_entries', 'dre', 'rateio', 'bases_rateio', 'expenses',
  'financial_plans', 'bank', 'defaulters', 'import_titles',
  'dnapay_gerar_titulos', 'dnapay_cobrancas_automaticas', 'dnapay_scheduler',
  'dnapay_renegociacao', 'dnapay_mensageria',
  'fiscal_dashboard', 'fiscal_emissao', 'fiscal_notas', 'fiscal_config',
  'fiscal_relatorios', 'fiscal_integracao', 'fiscal_logs', 'fiscal_erros',
  'tributario_dashboard', 'tributario_config', 'tributario_apuracao',
  'tributario_memoria', 'tributario_simulacoes', 'tributario_relatorios', 'tributario_logs',
  'executivo_dashboard', 'executivo_dre', 'executivo_segmentos', 'executivo_forecast',
  'relatorios', 'relatorio_consolidado', 'analytics',
  'students', 'communication',
];

// Portaria: apenas DNA GO
const PAGINAS_PORTARIA = [
  'dnago_painel', 'dnago_portaria', 'dnago_dashboard', 'dnago_autorizados',
  'dnago_retiradas', 'dnago_vans', 'dnago_ocorrencias',
];

export const PERMISSOES_PADRAO = {
  admin: gerarPermissoesPadrao(TODAS_PAGINAS_IDS),
  operador: gerarPermissoesPadrao(TODAS_PAGINAS_IDS),
  professor: gerarPermissoesPadrao(PAGINAS_PROFESSOR),
  teacher: gerarPermissoesPadrao(PAGINAS_PROFESSOR),
  coordenacao: gerarPermissoesPadrao(PAGINAS_COORDENACAO),
  secretaria: gerarPermissoesPadrao(PAGINAS_COORDENACAO),
  financeiro: gerarPermissoesPadrao(PAGINAS_FINANCEIRO),
  funcionario: gerarPermissoesPadrao(PAGINAS_PROFESSOR),
  viewer: gerarPermissoesPadrao([]),
  portaria: gerarPermissoesPadrao(PAGINAS_PORTARIA),
};

const PermissoesContext = createContext(null);

export const PermissoesProvider = ({ children }) => {
  const [permissoes, setPermissoes] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const getUserFromStorage = () => {
    try {
      const userStr = localStorage.getItem('user');
      return userStr ? JSON.parse(userStr) : null;
    } catch {
      return null;
    }
  };

  const loadPermissoes = async () => {
    // Nao carregar permissoes admin no contexto de familia
    if (window.location.pathname.startsWith('/familia')) {
      setPermissoes(null);
      setLoading(false);
      return;
    }

    const user = getUserFromStorage();
    
    if (!user) {
      setPermissoes(null);
      setLoading(false);
      return;
    }

    try {
      const res = await api.get('/users/me');
      const userData = res.data;
      
      if (userData.permissoes && userData.permissoes.paginas) {
        // Usar permissões personalizadas configuradas pelo admin
        setPermissoes(userData.permissoes);
      } else {
        // Usar permissões padrão do perfil
        const role = userData.role || user.role || 'professor';
        const permissoesPadrao = PERMISSOES_PADRAO[role] || PERMISSOES_PADRAO.professor;
        setPermissoes(permissoesPadrao);
      }
    } catch (error) {
      const role = user.role || 'professor';
      const permissoesPadrao = PERMISSOES_PADRAO[role] || PERMISSOES_PADRAO.professor;
      setPermissoes(permissoesPadrao);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPermissoes();
    
    const handleAuthChange = () => {
      loadPermissoes();
    };
    
    window.addEventListener('auth-change', handleAuthChange);
    window.addEventListener('storage', handleAuthChange);
    
    return () => {
      window.removeEventListener('auth-change', handleAuthChange);
      window.removeEventListener('storage', handleAuthChange);
    };
  }, []);
  
  const temAcessoPagina = (paginaId) => {
    if (!permissoes || !permissoes.paginas) return false;
    return permissoes.paginas[paginaId] === true;
  };

  const temPermissaoAcao = (paginaId, acao) => {
    const user = getUserFromStorage();
    if (user?.role === 'admin') return true;
    if (!permissoes?.paginas?.[paginaId]) return false;
    if (!permissoes?.acoes) return true;
    const cat = TODAS_PAGINAS[paginaId]?.categoria;
    const key = `${cat}.${paginaId}.${acao}`;
    if (!(key in permissoes.acoes)) return true;
    return permissoes.acoes[key] === true;
  };
  
  const temAcessoCategoria = (categoria) => {
    if (!permissoes || !permissoes.paginas) return false;
    return Object.keys(TODAS_PAGINAS).some(
      key => TODAS_PAGINAS[key].categoria === categoria && permissoes.paginas[key] === true
    );
  };
  
  const getPaginasPermitidas = () => {
    if (!permissoes || !permissoes.paginas) return [];
    return Object.keys(TODAS_PAGINAS).filter(key => permissoes.paginas[key] === true);
  };

  const isAdmin = () => {
    const user = getUserFromStorage();
    return user?.role === 'admin';
  };

  const isTeacher = () => {
    const user = getUserFromStorage();
    const role = user?.role?.toLowerCase();
    return role === 'teacher' || role === 'professor';
  };

  return (
    <PermissoesContext.Provider value={{ 
      permissoes, loading, 
      temAcessoPagina, temPermissaoAcao, temAcessoCategoria, getPaginasPermitidas,
      isAdmin, isTeacher, loadPermissoes 
    }}>
      {children}
    </PermissoesContext.Provider>
  );
};

export const usePermissoes = () => {
  const context = useContext(PermissoesContext);
  if (!context) {
    return { 
      permissoes: null, loading: true, 
      temAcessoPagina: () => false, temPermissaoAcao: () => false, temAcessoCategoria: () => false, 
      getPaginasPermitidas: () => [], isAdmin: () => false, isTeacher: () => false,
      loadPermissoes: () => {} 
    };
  }
  return context;
};
